/**
 * URLs that should skip the global spinner and use custom loading indicators instead
 * These patterns are matched against the full request URL
 */
export class SpinnerSkipUrlsConstants {
  
  // Add your URLs here that need custom spinner handling
  public static readonly SKIP_URLS: string[] = [
    '/linkedTrainingItemGroups',
    'TrainingItemGroup/lookup',
    '/documentVersionApproval',
    '/actionPlanDetails',
    'documenttemplates/documentFormattedFiles/documentFormattedFiles/'

  ];

  // Add any URLs that should only be matched if they appear at the end of the path
  public static readonly SkipWithEndOnlyUrls: string[] = [
    '/chat'
  ];
  
  /**
   * Check if a URL should skip the global spinner
   * @param url The request URL to check
   * @returns true if the URL should skip global spinner
   */
  public static shouldSkipSpinner(url: string): boolean {
     // Match if any SKIP_URLS pattern appears anywhere in the path
      const includesMatch = this.SKIP_URLS.some(skipUrl => !!skipUrl && url.includes(skipUrl));

      // Match if any SkipWithEndOnlyUrls matches the end of the path
      const endsWithMatch = this.SkipWithEndOnlyUrls.some(skipUrl => !!skipUrl && url.endsWith(skipUrl));

      return includesMatch || endsWithMatch;
  }
}
